<script setup lang="ts">
import type { ComboboxRootEmits, ComboboxRootProps } from 'reka-ui'
import { ComboboxRoot, useForwardPropsEmits } from 'reka-ui'

/*
 * Reka's Combobox — a text field that filters a listbox. What it brings over an
 * input beside a hand-filtered list: listbox/option roles, `aria-activedescendant`,
 * arrow-key movement from the field into the results, typeahead, and its own
 * locale-aware filtering (so no caller re-implements `toLowerCase().includes`).
 *
 * Unstyled root, as the registry ships it: the frame belongs to ComboboxAnchor.
 */
const props = defineProps<ComboboxRootProps>()
const emits = defineEmits<ComboboxRootEmits>()

const forwarded = useForwardPropsEmits(props, emits)
</script>

<template>
  <ComboboxRoot
    v-slot="slotProps"
    v-bind="forwarded"
  >
    <!-- `open` and `modelValue`, as the root exposes them — a caller that
         filters for itself needs to know when the list closed. -->
    <slot v-bind="slotProps" />
  </ComboboxRoot>
</template>
